export const RECORDS_PAGE_SIZE = 2000;

// Mirrors MAX_DISPLAY_NAME_LENGTH in hg/constants.py. Not in slug.ts with the
// nickname bounds: a display name is not a URL name and goes through none of
// that normalization.
export const MAX_DISPLAY_NAME_LENGTH = 64;

export const API_URL = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api`;

// Mirrors MAX_MEDIA_CAPTION_LENGTH in hg/constants.py. The API rejects
// anything longer, so the caption inputs stop the user at it.
export const MAX_MEDIA_CAPTION_LENGTH = 500;
